// 必要なし
export const ValidationRules = {
  // 外国政府等重要な公的地位にある方等とのお取引に該当する (国、職名)
  foreign_government_company: {
    isError: false,
    message: '国・職名は必ず入力してください。'
  },
  // 氏名
  surname_require: {
    isError: false,
    message: '氏名は必ず入力してください'
  },
  name_require: {
    isError: false
  },
  surname_japanese: {
    isError: false,
    message: '数字や半角カナや記号は入力はできません'
  },
  name_japanese: {
    isError: false
  },
  // 氏名 カナ
  surname_kana_require: {
    isError: false,
    message: 'カナ氏名は必ず入力してください'
  },
  name_kana_require: {
    isError: false
  },
  surname_kana_japanese: {
    isError: false,
    message: 'カナ氏名カタカナで必ず入力してください'
  },
  name_kana_japanese: {
    isError: false
  },
  surname_kana_range: {
    isError: false,
    message: 'セイは20文字までしか入力できません'
  },
  name_kana_range: {
    isError: false,
    message: 'メイは20文字までしか入力できません'
  },
  // 生年月日
  birthday_year_require: {
    isError: false
  },
  birthday_month_require: {
    isError: false
  },
  birthday_day_require: {
    isError: false
  },
  birthday_range: {
    isError: false,
    message: '年齢が18歳以上から68歳以下の人がご登録可能です'
  },
  // 郵便番号
  post_number_require: {
    isError: false,
    message: '郵便番号は必ず入力してください'
  },
  post_number_is_number: {
    isError: false,
    message: '郵便番号は必ず半角数字で入力してください'
  },
  post_number_search: {
    isError: false,
    message: '住所が見つかりませんでした。再度ご確認ください'
  },
  // 住所
  street_address1_require: {
    isError: false,
    message: '住所は必ず入力してください'
  },
  street_address1_is_address: {
    isError: false,
    message: '住所のフォーマットが間違えています'
  },
  street_address1_range: {
    isError: false,
    message: '住所は20文字までしか入力できません'
  },
  street_address2_require: {
    isError: false,
    message: '住所は必ず入力してください'
  },
  street_address2_range: {
    isError: false,
    message: '住所は20文字までしか入力できません'
  },
  // 住所カナ
  street_address_kana_require: {
    isError: false,
    message: '住所カナは必ず入力してください。'
  },
  street_address_kana_is_kana: {
    isError: false,
    message: '住所カナは必ずカタカナで入力してください。'
  },
  // 自宅電話番号
  fixed_phone1_is_number: {
    isError: false,
    message: '固定電話番号は半角数字で入力してください'
  },
  fixed_phone2_is_number: {
    isError: false
  },
  fixed_phone3_is_number: {
    isError: false
  },
  // 携帯電話番号
  mobile_phone1_require: {
    isError: false,
    message: '携帯電話番号は必ず入力してください'
  },
  mobile_phone2_require: {
    isError: false
  },
  mobile_phone3_require: {
    isError: false
  },
  mobile_phone1_is_number: {
    isError: false,
    message: '携帯電話番号は半角数字で入力してください'
  },
  mobile_phone2_is_number: {
    isError: false
  },
  mobile_phone3_is_number: {
    isError: false
  },

  // ご家族
  has_spouse_require: {
    isError: false,
    message: '配偶者の有無を選択してください'
  },
  parent_living_require: {
    isError: false,
    message: '親の同居の有無を選択してください'
  },
  child_status_require: {
    isError: false,
    message: '子供の有無を選択してください'
  },
  child_number_require: {
    isError: false,
    message: '子供の人数を入力してください'
  },
  others_status_require: {
    isError: false,
    message: 'その他家族の有無を選択してください'
  },
  others_number_require: {
    isError: false,
    message: 'その他家族の人数を入力してください'
  },
  // ご家族について
  family_about_require: {
    isError: false,
    message: 'ご家族についてを選択してください'
  },
  // 世帯人数（同一生計人数）
  family_structure_require: {
    isError: false,
    message: '世帯人数（同一生計人数）を選択してください'
  },
  // 住居
  residence_classification_require: {
    isError: false,
    message: '住居形態を選択してください'
  },
  residence_period_year_require: {
    isError: false,
    message: '居住年数を選択してください'
  },
  // residence_period_month_require: {
  //     isError: false,
  // },
  loan_rent_require: {
    isError: false,
    message: 'ローン・家賃の支払いを選択してください'
  },
  // 世帯主収入
  householder_income_require: {
    isError: false,
    message: '世帯主の税込年収は必ず入力してください'
  },
  // 世帯主所得種類
  householder_income_type_require: {
    isError: false,
    message: '世帯主の所得種類を選択してください'
  },
  householder_income_type_other_name_require: {
    isError: false,
    message: '世帯主の所得種類を入力してください'
  },
  householder_monthly_credit_payments_require: {
    isError: false,
    message: '世帯主のクレジット月間支払額を入力してください'
  },

  // 実家住所 郵便番号
  parents_post_require: {
    isError: false,
    message: '実家郵便番号は必ず入力してください'
  },
  parents_post_is_number: {
    isError: false,
    message: '実家郵便番号は半角数字で入力してください'
  },
  parents_post_search: {
    isError: false,
    message: '住所が見つかりませんでした。再度ご確認ください'
  },
  // 実家住所
  parents_address_require: {
    isError: false,
    message: '実家住所は必ず入力してください'
  },
  parents_address_is_address: {
    isError: false,
    message: '実家住所のフォーマットが間違えています'
  },
  parents_address_range: {
    isError: false,
    message: '実家住所は20文字までしか入力できません'
  },
  // 実家電話番号
  parents_phone1_require: {
    isError: false,
    message: '実家電話番号は必ず入力してください'
  },
  parents_phone2_require: {
    isError: false
  },
  parents_phone3_require: {
    isError: false
  },
  parents_phone1_is_number: {
    isError: false,
    message: '実家電話番号は半角数字で入力してください'
  },
  parents_phone2_is_number: {
    isError: false
  },
  parents_phone3_is_number: {
    isError: false
  },

  // お勤め先
  occupation_require: {
    isError: false,
    message: 'お勤め先・学校を選択してください'
  },
  occupation_other_name_require: {
    isError: false,
    message: 'お勤め先・学校を入力してください'
  },
  employment_status_require: {
    isError: false,
    message: '就業形態を選択してください'
  },
  employment_status_other_name_require: {
    isError: false,
    message: '就業形態を入力してください'
  },

  graduate_year_require: {
    isError: false,
    message: '卒業予定を入力してください'
  },
  graduate_month_require: {
    isError: false
  },
  company_name_require: {
    isError: false,
    message: 'お勤め先を入力してください'
  },
  company_name_kana_require: {
    isError: false,
    message: 'お勤め先フリガナを入力してください'
  },

  company_post_require: {
    isError: false,
    message: 'お勤め先郵便番号は必ず入力してください'
  },
  company_post_is_number: {
    isError: false,
    message: 'お勤め先郵便番号は半角数字で必ず入力してください'
  },
  company_post_search: {
    isError: false,
    message: '住所が見つかりませんでした。再度ご確認ください'
  },
  company_address_require: {
    isError: false,
    message: 'お勤め先住所は必ず入力してください'
  },
  company_address_is_address: {
    isError: false,
    message: 'お勤め先住所のフォーマットが間違えています'
  },
  company_address_range: {
    isError: false,
    message: 'お勤め先住所は20文字までしか入力できません'
  },
  company_phone1_require: {
    isError: false,
    message: 'お勤め先電話番号は必ず入力してください'
  },
  company_phone2_require: {
    isError: false
  },
  company_phone3_require: {
    isError: false
  },
  company_phone1_is_number: {
    isError: false,
    message: 'お勤め先電話番号半角数字で入力してください'
  },
  company_phone2_is_number: {
    isError: false
  },
  company_phone3_is_number: {
    isError: false
  },

  // 仕事内容
  company_job_description_require: {
    isError: false,
    message: '仕事内容を選択してください'
  },
  company_job_description_other_name_require: {
    isError: false,
    message: '仕事内容を入力してください'
  },

  // 所属部課
  job_department_require: {
    isError: false,
    message: '所属部課を入力してください'
  },

  // 派遣元
  dispatched_agent_require: {
    isError: false,
    message: '出向派遣元を入力してください'
  },

  // 入社年月
  join_year_require: {
    isError: false,
    message: '入社年月を選択してください'
  },
  join_month_require: {
    isError: false,
    message: ''
  },
  // 給料日
  payday_required: {
    isError: false,
    message: '給料日を入力してください'
  },
  // 税込年収
  company_income_require: {
    isError: false,
    message: '税込年収を入力してください'
  },
  // その他収入
  sideline_type_require: {
    isError: false,
    message: 'その他収入を選択してください'
  },
  sideline_other_name_require: {
    isError: false,
    message: 'その他収入を入力してください'
  }
}

import {AgeLimit} from '@/js/util/constants'

/**
 * 個人情報画面のバリデーションルール
 * @param {object} common
 * @param {object} unique
 */
export const ValidationRulesFun = (common, unique) => {
  const copy = JSON.parse(JSON.stringify(common))
  for (let key in unique) {
    if (common[key]) {
      copy[key].push(...unique[key])
    } else {
      copy[key] = unique[key]
    }
  }
  return copy
}

/**
 * 個人情報入力画面のバリデーション共通
 */
export const ValidationRulesCommon = {
  // 申込日(年)
  application_date_year: [
    {rule: 'required', event: 'blur', action: 'select', error_add: 'application_date'},
    {rule: 'date:application_date_month:application_date_day', event: 'blur', error_add: 'application_date'}
  ],
  // 申込日(月)
  application_date_month: [
    {rule: 'required', event: 'blur', action: 'select', error_add: 'application_date'},
    {rule: 'date:application_date_year:application_date_day', event: 'blur', error_add: 'application_date'}
  ],
  // 申込日(日)
  application_date_day: [
    {rule: 'required', event: 'blur', action: 'select', error_add: 'application_date'},
    {rule: 'date:application_date_month:application_date_year', event: 'blur', error_add: 'application_date'}
  ],
  // 氏名 姓
  surname: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'name'},
    {rule: 'string', event: 'input', error_add: 'name'},
    {rule: 'maxlen:50', event: 'input', error_add: 'name'}
  ],
  // 氏名 名
  first_name: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'name'},
    {rule: 'string', event: 'input', error_add: 'name'},
    {rule: 'maxlen:50', event: 'input', error_add: 'name'}
  ],
  // 氏名 姓 カナ
  surname_kana: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'name_kana'},
    {rule: 'string', event: 'input', error_add: 'name_kana'},
    {rule: 'kana', event: 'blur', error_add: 'name_kana'},
    {rule: 'maxlen:50', event: 'input', error_add: 'name_kana'}
  ],
  // 氏名 名 カナ
  first_name_kana: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'name_kana'},
    {rule: 'string', event: 'input', error_add: 'name_kana'},
    {rule: 'kana', event: 'blur', error_add: 'name_kana'},
    {rule: 'maxlen:50', event: 'input', error_add: 'name_kana'}
  ],
  // 旧姓 漢字
  old_surname: [
    {rule: 'string', event: 'input', error_add: 'old_surname'},
    {rule: 'maxlen:50', event: 'input', error_add: 'old_surname'}
  ],
  // 旧姓 カナ
  old_surname_kana: [
    {rule: 'string', event: 'input', error_add: 'old_surname_kana'},
    // {rule: 'kana', event: 'blur', error_add: 'old_surname_kana'},
    {rule: 'maxlen:50', event: 'input', error_add: 'old_surname_kana'}
  ],
  // 性別
  sex_type: [{rule: 'required', event: 'blur', action: 'radio'}],
  // 生年月日(年)
  birthday_year: [
    {rule: 'required', event: 'blur,change', action: 'select', error_add: 'birthday', message: '申込年齢対象外です。'},
    {rule: 'date:birthday_month:birthday_day', event: 'blur', error_add: 'application_date'}
  ],
  // 生年月日(月)
  birthday_month: [
    {rule: 'required', event: 'blur,change', action: 'select', error_add: 'birthday', message: '申込年齢対象外です。'},
    {rule: 'date:birthday_year:birthday_day', event: 'blur', error_add: 'application_date'}
  ],
  // 生年月日(日)
  birthday_day: [
    {rule: 'required', event: 'blur,change', action: 'select', error_add: 'birthday', message: '申込年齢対象外です。'},
    {rule: 'date:birthday_year:birthday_month', event: 'blur', error_add: 'application_date'}
  ],
  // 郵便番号
  post_number: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'post', event: 'blur'}
  ],
  // 郵便番号検索結果
  post_number_search: [{rule: 'message_custom:住所が見つかりませんでした。再度ご確認ください', event: 'blur'}],
  // 住所1
  street_address1: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'address', event: 'blur'},
    {rule: 'maxlen:120', event: 'input'},
    {rule: 'string', event: 'input'}
  ],
  // 住所2
  street_address2: [
    {rule: 'maxlen:190', event: 'input'},
    {rule: 'string', event: 'input'}
  ],
  // 住所カナ
  street_address_kana: [
    {rule: 'string', event: 'input'},
    {rule: 'maxlen:150', event: 'input'}
  ],
  // 自宅電話番号1
  fixed_phone1: [
    {rule: 'integer', event: 'input', error_add: 'fixed_phone'},
    {rule: 'string', event: 'input', error_add: 'fixed_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'fixed_phone'}
  ],
  // 自宅電話番号2
  fixed_phone2: [
    {rule: 'integer', event: 'input', error_add: 'fixed_phone'},
    {rule: 'string', event: 'input', error_add: 'fixed_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'fixed_phone'}
  ],
  // 自宅電話番号3
  fixed_phone3: [
    {rule: 'integer', event: 'input', error_add: 'fixed_phone'},
    {rule: 'string', event: 'input', error_add: 'fixed_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'fixed_phone'}
  ],
  // 携帯番号1
  mobile_phone1: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'mobile_phone'},
    {rule: 'integer', event: 'input', error_add: 'mobile_phone'},
    {rule: 'string', event: 'input', error_add: 'mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'mobile_phone'}
  ],
  // 携帯番号2
  mobile_phone2: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'mobile_phone'},
    {rule: 'integer', event: 'input', error_add: 'mobile_phone'},
    {rule: 'string', event: 'input', error_add: 'mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'mobile_phone'}
  ],
  // 携帯番号3
  mobile_phone3: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'mobile_phone'},
    {rule: 'integer', event: 'input', error_add: 'mobile_phone'},
    {rule: 'string', event: 'input', error_add: 'mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'mobile_phone'}
  ],
  // // 配偶者
  // has_spouse: [
  //     { rule: 'required', event: 'change', action: 'radio' },
  // ],
  // // 親同伴
  // parent_living: [
  //     { rule: 'required', event: 'change', action: 'radio' },
  // ],
  // // 子供あり
  // child_status: [
  //     { rule: 'required', event: 'change', action: 'radio' },
  // ],
  // // 子供人数
  // child_number: [
  //     { rule: 'required_if:child_status,有', event: 'blur', action: 'input' },
  // ],
  // // その他あり
  // others_status: [
  //     { rule: 'required', event: 'change', action: 'radio' },
  // ],
  // // その他人数
  // others_number: [
  //     { rule: 'required_if:others_status,有', event: 'blur', action: 'input' },
  // ],
  // ご家族について
  // family_about: [{rule: 'required', event: 'blur,change', action: 'select'}],
  // ご家族についての同居人数
  family_about_number: [
    {rule: 'integer', event: 'input'},
    {rule: 'max:2', event: 'input'},
    {rule: 'limit:1,lower,人', event: 'input', message: '同居人数は申込者本人も含みます。'}
  ],
  // 実家住所 郵便番号
  parents_post: [{rule: 'post', event: 'blur'}],
  // 実家住所 郵便番号検索結果
  parents_post_search: [{rule: 'message_custom:住所が見つかりませんでした。再度ご確認ください', event: 'blur'}],
  // お勤め先・学校について
  occupation: [{rule: 'required', event: 'blur', action: 'select'}],
  // お勤め先・学校について　その他の場合のテキスト
  occupation_other_name: [
    {rule: 'required_if:occupation,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'inpuut'},
    {rule: 'maxlen:50', event: 'inpuut'}
  ],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'integer', event: 'input', error_add: 'company_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'company_phone'},
    {rule: 'string', event: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'integer', event: 'input', error_add: 'company_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'company_phone'},
    {rule: 'string', event: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'integer', event: 'input', error_add: 'company_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'company_phone'},
    {rule: 'string', event: 'input', error_add: 'company_phone'}
  ],
  // お勤め先名
  company_name: [
    {rule: 'string', event: 'input'},
    {rule: 'maxlen:40', event: 'input'}
  ],
  // お勤め先カナ
  company_name_kana: [
    {rule: 'company_kana', event: 'blur'},
    {rule: 'string', event: 'input'},
    {rule: 'maxlen:40', event: 'input'}
  ],
  // 仕事内容　その他の場合のテキスト
  company_job_description_other_name: [
    {rule: 'required_if:company_job_description,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'inpuut'},
    {rule: 'maxlen:50', event: 'inpuut'}
  ],
  // 所属部課
  job_department: [
    {rule: 'maxlen:40', event: 'input'},
    {rule: 'string', event: 'input'}
  ],
  // 出向派遣元
  dispatched_agent: [
    {rule: 'maxlen:40', event: 'input'},
    {rule: 'string', event: 'input'}
  ],
  // 勤め先郵便番号
  company_post: [{rule: 'post', event: 'input'}],
  // 勤め先郵便番号検索結果
  company_post_search: [{rule: 'message_custom:住所が見つかりませんでした。再度ご確認ください', event: 'blur'}],
  // 勤め先住所
  company_address: [
    {rule: 'address', event: 'blur'},
    {rule: 'string', event: 'blur'},
    {rule: 'maxlen:40', event: 'input'}
  ],
  // 税込年収
  company_income: [
    {rule: 'integer', event: 'input'},
    {rule: 'more:1',event: 'blur', action: 'input'},
  ],
  // その他収入(年額) のその他テキスト
  sideline_other_name: [
    {rule: 'required_if:sideline_type,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'blur'},
    {rule: 'maxlen:40', event: 'input'}
  ],
  // その他収入 税込年収
  sideline_income: [{rule: 'integer', event: 'input'}]
}

/**
 * 個人情報入力画面のバリデーション信販
 */
export const ValidationRulesCredit = {
  // 取引を行う目的
  purpose_of_transaction: [{rule: 'required', event: 'blur', action: 'select'}],
  // 取引を行う目的 その他の場合のテキスト
  purpose_of_transaction_other_name: [
    {rule: 'required_if:purpose_of_transaction,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
  ],
  // 外国政府等重要な公的地位にある方等とのお取引に該当する
  is_foreign_government: [{rule: 'required', event: 'blur', action: 'radio', error_add: 'is_foreign_government'}],
  // 外国政府等重要な公的地位にある方等とのお取引に該当する (国、職名)
  foreign_government_company: [
    {
      rule: 'required_if:is_foreign_government,はい',
      event: 'blur',
      action: 'input',
      error_add: 'foreign_government_company'
    },
    {rule: 'string', event: 'input', error_add: 'foreign_government_company'},
    {rule: 'max:50', event: 'input', error_add: 'foreign_government_company'}
  ],
  // 生年月日(年)
  birthday_year: [
    {
      rule: `birthday_range:birthday_month,birthday_day:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(月)
  birthday_month: [
    {
      rule: `birthday_range:birthday_year,birthday_day:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(日)
  birthday_day: [
    {
      rule: `birthday_range:birthday_month,birthday_year:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // ご家族について
  family_about: [{rule: 'required', event: 'blur,change', action: 'select'}],
  // ご家族についての同居人数
  family_about_number: [{rule: 'required', event: 'blur', action: 'input'}],
  // 生計同一人数
  family_structure: [
    {rule: 'required', event: 'blur,change', action: 'select'}
    // { rule: 'required', event: 'change', action: 'select' },
  ],
  // 住宅ローン・家賃のお支払い
  loan_rent: [{rule: 'required', event: 'blur', action: 'radio'}],
  // お申込者と世帯主の関係
  householder_relation: [{rule: 'required', event: 'blur', action: 'select'}],
  // 世帯主の税込年収
  householder_income: [
    {
      rule: `required_if:occupation,専業主婦|householder_relation,配偶者|occupation,学生（アルバイト）&householder_relation,配偶者`,
      event: 'blur',
      action: 'select'
    },
    {rule: 'integer', event: 'input'}
    // { rule: 'required_if:householder_relation,配偶者', event: 'blur', action: 'select' },
    // { rule: 'required_if:occupation,学生&householder_relation,配偶者', event: 'blur', action: 'select' },
  ],
  // 世帯主の所得種類
  householder_income_type: [
    {
      rule: `required_if:occupation,専業主婦|householder_relation,配偶者|occupation,学生（アルバイト）&householder_relation,配偶者`,
      event: 'blur,change',
      action: 'select'
    }
    // { rule: 'required_if:householder_relation,配偶者', event: 'blur,change', action: 'select' },
    // { rule: 'required_if:occupation,学生&householder_relation,配偶者', event: 'blur,change', action: 'select' },
  ],
  // 世帯主の所得種類 その他の場合のテキスト
  householder_income_type_other_name: [
    {
      rule: `required_if:householder_income_type,その他&occupation,専業主婦|householder_income_type,その他&householder_relation,配偶者|householder_income_type,その他&occupation,学生（アルバイト）&householder_relation,配偶者`,
      event: 'blur',
      action: 'input'
    },
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
    // { rule: 'required_if:householder_income_type,その他&householder_relation,配偶者', event: 'blur', action: 'input' },
    // { rule: 'required_if:householder_income_type,その他&occupation,学生&householder_relation,配偶者', event: 'blur', action: 'input' },
  ],
  // 世帯主のクレジット月間支払い額
  householder_monthly_credit_payments: [
    {
      rule: `required_if:occupation,専業主婦|householder_relation,配偶者|occupation,学生（アルバイト）&householder_relation,配偶者`,
      event: 'blur',
      action: 'input'
    },
    {rule: 'integer', event: 'input'}
    // { rule: 'required_if:householder_relation,配偶者', event: 'blur', action: 'input' },
    // { rule: 'required_if:occupation,学生&householder_relation,配偶者', event: 'blur', action: 'input' },
  ],
  // 実家住所 郵便番号
  parents_post: [
    {rule: 'required', event: 'blur', action: 'input'},
  ],
  // 実家住所
  parents_address: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'address', event: 'blur'},
    {rule: 'maxlen:190', event: 'input'}
  ],
  /// 実家電話番号1
  parents_phone1: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家電話番号2
  parents_phone2: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家電話番号3
  parents_phone3: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家携帯電話番号1
  parents_mobile_phone1: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話番号2
  parents_mobile_phone2: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話番号3
  parents_mobile_phone3: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話続柄
  parents_phone_relationship: [
    {rule: 'string', event: 'blur', error_add: 'parents_phone_relationship'},
    {rule: 'maxlen:50', event: 'input', error_add: 'parents_phone_relationship'}
  ],
  parents_phone_relationship_other_name: [
    {rule: 'required_if:parents_phone_relationship,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
  ],
  // 卒業予定(年)
  graduate_year: [
    {rule: 'required_if:occupation,学生（アルバイト）|occupation,学生', event: 'blur,change', action: 'select'}
  ],
  // 卒業予定(月)
  graduate_month: [
    {rule: 'required_if:occupation,学生（アルバイト）|occupation,学生', event: 'blur,change', action: 'select'}
  ],
  // お勤め先名
  company_name: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input'}],
  // お勤め先カナ
  company_name_kana: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input'}],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // 仕事内容
  company_job_description: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'select'}],
  // 勤め先郵便番号
  company_post: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input'}],
  // 勤め先住所
  company_address: [
    {rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input', error_add: 'company_address'}
  ],
  // 入社年月(年)
  join_year: [
    {rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'select', },
  ],
  // 入社年月(月)
  join_month: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'select', }],
  // 給料日
  payday: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'select'}],
  // 税込年収
  company_income: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input'}],
  // ご住居
  residence_classification: [{rule: 'required', event: 'blur', action: 'select'}],
  // 居住年数
  residence_period_year: [{rule: 'required', event: 'blur', action: 'select'}]
}

/**
 * 個人情報入力画面のバリデーション自社割賦
 */
export const ValidationRulesInstallment = {
  // 生計同一人数
  family_structure: [
    {rule: 'required', event: 'blur,change', action: 'select'}
  ],
  // お申込者と世帯主の関係
  householder_relation: [
    {rule: 'required', event: 'blur', action: 'select'}
  ],
  // 生年月日(年)
  birthday_year: [
    {
      rule: `birthday_range:birthday_month,birthday_day:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(月)
  birthday_month: [
    {
      rule: `birthday_range:birthday_year,birthday_day:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(日)
  birthday_day: [
    {
      rule: `birthday_range:birthday_month,birthday_year:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // ご家族について
  family_about: [{rule: 'required', event: 'blur,change', action: 'select'}],
  // ご家族についての同居人数
  family_about_number: [{rule: 'required', event: 'blur', action: 'input'}],
  // お勤め先名
  company_name: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // お勤め先カナ
  company_name_kana: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // 仕事内容
  company_job_description: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'select'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // 税込年収
  company_income: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // ご住居
  residence_classification: [{rule: 'required', event: 'blur', action: 'select'}],
  // 居住年数
  residence_period_year: [{rule: 'required', event: 'blur', action: 'select'}],
  // 実家住所 郵便番号
  parents_post: [
    {rule: 'required', event: 'blur', action: 'input'},
  ],
  // 実家住所
  parents_address: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'address', event: 'blur'},
    {rule: 'maxlen:190', event: 'input'}
  ],
  /// 実家電話番号1
  parents_phone1: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家電話番号2
  parents_phone2: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家電話番号3
  parents_phone3: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家携帯電話番号1
  parents_mobile_phone1: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話番号2
  parents_mobile_phone2: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話番号3
  parents_mobile_phone3: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話続柄
  parents_phone_relationship: [
    {rule: 'string', event: 'blur', error_add: 'parents_phone_relationship'},
    {rule: 'maxlen:50', event: 'input', error_add: 'parents_phone_relationship'}
  ],
  parents_phone_relationship_other_name: [
    {rule: 'required_if:parents_phone_relationship,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
  ]
}

/**
 * 個人情報入力画面のバリデーション信販追加申込
 */
export const ValidationRulesAddCredit = {
  // 生年月日(年)
  birthday_year: [
    {
      rule: `birthday_range:birthday_month,birthday_day:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(月)
  birthday_month: [
    {
      rule: `birthday_range:birthday_year,birthday_day:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(日)
  birthday_day: [
    {
      rule: `birthday_range:birthday_month,birthday_year:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // お勤め先名
  company_name: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input'}],
  // お勤め先カナ
  company_name_kana: [{rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input'}],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'required_unless:occupation,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  is_change_customer: [{rule: 'required', event: 'blue', action: 'radio'}],
  // 実家携帯電話の続柄(その他)
  parents_phone_relationship_other_name: [
    {rule: 'required_if:parents_phone_relationship,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
  ],
}

/**
 * 個人情報入力画面のバリデーション自社割賦追加
 */
export const ValidationRulesAddInstallment = {
  // 生年月日(年)
  birthday_year: [
    {
      rule: `birthday_range:birthday_month,birthday_day:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(月)
  birthday_month: [
    {
      rule: `birthday_range:birthday_year,birthday_day:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(日)
  birthday_day: [
    {
      rule: `birthday_range:birthday_month,birthday_year:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // ご家族について
  family_about: [{rule: 'required', event: 'blur,change', action: 'select'}],
  // ご家族についての同居人数
  family_about_number: [{rule: 'required', event: 'blur', action: 'input'}],
  // お勤め先名
  company_name: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // お勤め先カナ
  company_name_kana: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // 仕事内容
  company_job_description: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'select'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'select'}
  ],
  // 税込年収
  company_income: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  is_change_customer: [{rule: 'required', event: 'blue', action: 'radio'}],
  // ご住居
  residence_classification: [{rule: 'required', event: 'blur', action: 'select'}],
  // 居住年数
  residence_period_year: [{rule: 'required', event: 'blur', action: 'select'}]
}
